/**
 *
 * @type {{GGBP: {symbol: string, digits: number, locale: string}, GBP: {symbol: string, digits: number, locale: string}, GUSD: {symbol: string, digits: number, locale: string}, USD: {symbol: string, digits: number, locale: string}, GSEK: {symbol: string, digits: number, locale: string}, SEK: {symbol: string, digits: number, locale: string}, GDKK: {symbol: string, digits: number, locale: string}, DKK: {symbol: string, digits: number, locale: string}, EUR: {symbol: string, digits: number, locale: string}, DIA: {symbol: string, symbolShort: string, digits: number, locale: string}, CAD: {symbol: string, digits: number, locale: string}}}
 */
var GDC_CODES = {
    GGBP: {
        symbol: 'G\u00a3',
        digits: 0,
        factor: 100,
        locale: 'en-GB',
    },
    GBP: {
        symbol: '\u00a3',
        digits: 2,
        factor: 1,
        locale: 'en-GB',
    },
    GUSD: {
        symbol: 'G$',
        digits: 0,
        factor: 100,
        locale: 'en-US',
    },
    USD: {
        symbol: '$',
        digits: 2,
        factor: 1,
        locale: 'en-US',
    },
    GSEK: {
        symbol: 'Gkr',
        digits: 0,
        factor: 100,
        locale: 'sv-SE',
    },
    SEK: {
        symbol: 'kr',
        digits: 2,
        factor: 1,
        locale: 'sv-SE',
    },
    GDKK: {
        symbol: 'Gkr',
        digits: 0,
        factor: 100,
        locale: 'da-DK',
    },
    DKK: {
        symbol: 'kr.',
        digits: 2,
        factor: 1,
        locale: 'da-DK',
    },
    EUR: {
        symbol: '\u20ac',
        digits: 2,
        factor: 1,
        locale: 'de',
    },
    DIA: {
        symbol: 'Diamants',
        // symbolShort: 'D',
        digits: 0,
        factor: 100,
        locale: 'fr',
    },
    CAD: {
        symbol: '$',
        digits: 2,
        factor: 1,
        locale: 'en-CA',
    },
    CRED: {
        symbol: 'Credits',
        digits: 0,
        factor: 100,
        locale: 'en-US',
    },
};
var GDC_CODES_FALLBACK = {
    GGBP: {
        exp: GDC_CODES.GGBP.symbol + "{num}",
    },
    GBP: {
        exp: GDC_CODES.GBP.symbol + "{num}",
    },
    GUSD: { exp: GDC_CODES.GUSD.symbol + "{num}" },
    USD: { exp: GDC_CODES.USD.symbol + "{num}" },
    GSEK: { exp: "{num}\u00A0" + GDC_CODES.GSEK.symbol },
    SEK: { exp: "{num}\u00A0" + GDC_CODES.SEK.symbol },
    GDKK: { exp: "{num}\u00A0" + GDC_CODES.GDKK.symbol },
    DKK: { exp: "{num}\u00A0" + GDC_CODES.DKK.symbol },
    EUR: { exp: "{num}\u00A0" + GDC_CODES.EUR.symbol },
    DIA: { exp: "{num}\u00A0" + GDC_CODES.DIA.symbol },
    CAD: { exp: GDC_CODES.CAD.symbol + "{num}" },
    CRED: { exp: "{num}\u00A0" + GDC_CODES.CRED.symbol },
};
export default GDC_CODES;
export { GDC_CODES, GDC_CODES_FALLBACK };
//# sourceMappingURL=GDC_CODES.js.map